import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Role, SuccessRequest, User } from "@app/shared/common";
import { Store } from "@ngrx/store";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Login } from "../models/login.model";
import {
  RequestResetPassword,
  ResetPassword,
} from "../models/reset-password.model";
// import { ModuleConfigService } from '../../config/module-config.service';

@Injectable({
  providedIn: "root",
})
export class AuthService {
  /**
   * @description
   * This service contains everything related to user authentication
   */

  /**
   * * General
   * @roles Set all user roles
   * @apiUrl Get API url from NGRX store
   */
  public roles = Role;
  apiUrl: string;
  /**
   * * Observalbes
   */
  public userSubject: BehaviorSubject<any>;
  public user: Observable<User>;
  /**
   * * Client user
   */
  clientUserSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public clientUser: Observable<User>;

  constructor(
    // private appConfig: ModuleConfigService,
    private http: HttpClient,
    private router: Router,
    private store: Store<{ config: any }>
  ) {
    /**
     * Get config from ngrx store
     */
    store.select("config").subscribe((res) => {
      this.apiUrl = res.apiUrl;
    });
    this.userSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem("user") || "{}")
    );
    this.user = this.userSubject.asObservable();
  }

  public get userValue(): User {
    return this.userSubject.value;
  }

  public get clientUserValue(): User {
    return this.clientUserSubject.value;
  }

  public set setUserValue(user: any) {
    const currentUserData = JSON.parse(localStorage.getItem("user"));
    currentUserData.data = user;
    localStorage.setItem("user", JSON.stringify(currentUserData));
    this.userSubject.next(currentUserData);
  }

  /* ====================================
  *             MAIN FEATURES
  ======================================= */

  /**
   * @param credentials Provide user email & password
   * @returns logged user data
   */
  // login(credentials: Login) {
  //   return this.http
  //     .post<any>(`${this.apiUrl}/api/admin/login`, credentials)
  //     .pipe(
  //       map((user) => {
  //         console.log(user);
  //         // Store user and token to local storage
  //         localStorage.setItem("user", JSON.stringify(user));
  //         this.userSubject.next(user);
  //         this.router.navigate(["/upload"]);
  //         return user;
  //       })
  //     );
  // }

  login() {
    console.log(this.apiUrl);
    const apiPath = `${this.apiUrl}/auth/redirect`;
    const popup = window.open(apiPath, "_blank", "width=500,height=500");

    window.addEventListener(
      "message",
      (event) => {
        console.log(event);

        if (event.origin !== this.apiUrl) return;

        localStorage.setItem("user", JSON.stringify({ data: event.data }));
        this.userSubject.next({ data: event.data });
        this.router.navigate(["/upload"]);
      },
      false
    );
  }

  impersonate(user_id: number) {
    return this.http
      .post<any>(`${this.apiUrl}/api/admin/impersonate`, { user_id })
      .pipe(
        map((user) => {
          console.log(user);
          // Store user and token to local storage

          localStorage.setItem("superadmin", JSON.stringify(this.userValue));
          localStorage.setItem(
            "user",
            JSON.stringify({ ...user, impersonate: true })
          );
          this.userSubject.next({ ...user, impersonate: true });
          this.router.navigate([`/${user.data.route_permissions[0]}`]);
          return { ...user, impersonate: true };
        })
      );
  }

  cancelImpersonate() {
    return this.http.post(`${this.apiUrl}/api/admin/logout`, "").pipe(
      map((responseData) => {
        // remove user from local storage to log user out
        const user = localStorage.getItem("superadmin");
        localStorage.setItem("user", user);
        localStorage.removeItem("superadmin");
        this.userSubject.next(JSON.parse(user));
        this.router.navigate(["/companies"]);
        return responseData;
      })
    );
  }

  logout() {
    return this.http.post(`${this.apiUrl}/api/admin/logout`, "").pipe(
      map((responseData) => {
        // remove user from local storage to log user out
        localStorage.removeItem("user");
        localStorage.removeItem("superadmin");
        this.userSubject.next(null);
        this.router.navigate(["/login"]);
        return responseData;
      })
    );
  }

  /**
   * @param authorizedUsers Array with all users allowed access to the route
   * @returns is user authorized for route or not
   */
  isAuthorized(authorizedUsers: string[]): boolean {
    const currentUserRole = Object.keys(this.roles)[
      Object.values(this.roles).indexOf(this.userValue.data.role_id)
    ];
    if (authorizedUsers.includes(currentUserRole)) {
      return false;
    }
    return true;
  }

  getResetPasswordEmail(data: RequestResetPassword) {
    return this.http.post(`${this.apiUrl}/api/admin/forgot-password`, data);
  }

  resetPassword(resetPasswordData: ResetPassword) {
    return this.http.post(
      `${this.apiUrl}/api/admin/reset-password`,
      resetPasswordData
    );
  }

  createInitialUser(data: any) {
    return this.http.post<SuccessRequest>(
      `${this.apiUrl}/api/admin/user/configuration`,
      data
    );
  }
}
